import { instance as axios } from "@/store/_AXIOS"
import { _TOKEN, _DECODE } from "@/store/_JWT"

const TABLE = "/comprovativo/"
let isClicked = false

// initial state
const state = {
  data: []
}

// getters
const getters = {}

// actions
const actions = {
  ComprovativoDonativo({ dispatch }, params) {
    if (isClicked) return undefined
    isClicked = true

    setTimeout(() => {
      isClicked = false
    }, this._vm.$holdTime)

    return axios
      .post(TABLE + "donativo/", _TOKEN(params))
      .then(res => {
        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  },

  ComprovativoCota({ dispatch }, params) {
    if (isClicked) return undefined

    isClicked = true

    setTimeout(() => {
      isClicked = false
    }, this._vm.$holdTime)

    return axios
      .post(TABLE + "cota/", _TOKEN(params))
      .then(res => {
        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  }
}

// mutations
const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
